import { GET_REQUESTS_BY_CLIENT, RESET_PAGE_CLIENT_LOGS } from '../actions/actionTypes';

const initialState = {
  isLoading: false,
  page: 1,
  totalPages: 1,
  requests: []
};

const clientReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_REQUESTS_BY_CLIENT:
      return { ...state, ...action.data };
    case RESET_PAGE_CLIENT_LOGS:
      return { ...initialState };
    default:
      return state;
  }
};

export default clientReducer;
